import { Icon, ShadowStyles, Text } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Skeleton } from 'native-base';
import React from 'react';
import { Pressable, StyleSheet } from 'react-native';

interface AdvisorOptionProps {
  label: string;
  value: number;
  selected?: boolean;
  loading?: boolean;
  onSelect: (advisorId: number) => void;
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: Utils.Token.ToInt(Spacing, 'inline.xxxs'),
    borderRadius: Utils.Token.ToInt(BoxRadius, 'sm'),
    backgroundColor: Color['neutral.white'],
    gap: Utils.Token.ToInt(Spacing, 'inline.nano'),
    borderWidth: 1,
    borderColor: 'transparent',
  },
  selected: {
    borderColor: Color['brand.tertiary.light'],
  },
});

export const AdvisorOption: React.FC<AdvisorOptionProps> = ({
  label,
  value,
  selected = false,
  onSelect,
  loading,
}) => {
  const handleSelect = () => {
    onSelect(value);
  };

  return (
    <Pressable
      style={[{ ...ShadowStyles.Level[1] }, styles.container, selected && styles.selected]}
      onPress={handleSelect}>
      {loading ? (
        <Skeleton
          width="full"
          minWidth="full"
          height={Spacing['inset.xs']}
          borderRadius={BoxRadius.sm}
        />
      ) : (
        <>
          <Text>{label}</Text>
          <Icon
            name={selected ? 'RadioChecked' : 'RadioUnchecked'}
            size="xs"
            color={Color['neutral.dark']}
          />
        </>
      )}
    </Pressable>
  );
};
